const ORGANISATION_SWITCH_KEY = "privacy.organisationSwitch";

export const markOrganisationSwitch = () => {
  try {
    sessionStorage.setItem(ORGANISATION_SWITCH_KEY, "1");
  } catch {
    return;
  }
};

export const takeOrganisationSwitch = () => {
  try {
    const isSwitch = sessionStorage.getItem(ORGANISATION_SWITCH_KEY) === "1";
    sessionStorage.removeItem(ORGANISATION_SWITCH_KEY);
    return isSwitch;
  } catch {
    return false;
  }
};
